import React, { useState } from 'react';

const Process: React.FC = () => {
  const [openStep, setOpenStep] = useState<number | null>(1);

  const toggleStep = (id: number) => {
    setOpenStep(openStep === id ? null : id);
  };

  const steps = [
    {
      id: 1,
      title: '初回法律相談',
      subtitle: '現状把握と処分方針の決定',
      icon: 'ri-discuss-line',
      color: 'border-beige-200',
      bgColor: 'bg-beige-50',
      iconBg: 'bg-navy-800',
      iconColor: 'text-white',
      image: 'https://static.readdy.ai/image/5e182d52a94dfeeda6703180d188c585/56d05dcc73b568175369117352a6022c.jpeg'
    },
    {
      id: 2,
      title: '物件調査・法的検討',
      subtitle: '権利関係と処分可能性の精査',
      icon: 'ri-search-line',
      color: 'border-beige-200',
      bgColor: 'bg-beige-50',
      iconBg: 'bg-navy-800',
      iconColor: 'text-white',
      image: 'https://public.readdy.ai/ai/img_res/c90f0e15e06c055b5cccae72c4c2f384.jpg'
    },
    {
      id: 3,
      title: '譲渡先の開拓・交渉',
      subtitle: '隣接地所有者や関係機関との調整',
      icon: 'ri-handshake-line',
      color: 'border-beige-200',
      bgColor: 'bg-beige-50',
      iconBg: 'bg-navy-800',
      iconColor: 'text-white',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20between%20two%20people%20in%20suits%2C%20hands%20only%20visible%20without%20showing%20faces%2C%20formal%20business%20meeting%20setting%20with%20documents%20on%20table%2C%20clean%20office%20environment&width=400&height=300&seq=process3new&orientation=landscape'
    },
    {
      id: 4,
      title: '契約書作成・手続き完了',
      subtitle: '法的リスクを回避した確実な処分',
      icon: 'ri-file-check-line',
      color: 'border-beige-200',
      bgColor: 'bg-beige-50',
      iconBg: 'bg-navy-800',
      iconColor: 'text-white',
      image: 'https://readdy.ai/api/search-image?query=Legal%20contract%20documents%20and%20official%20papers%20on%20wooden%20desk%2C%20fountain%20pen%20and%20official%20seals%2C%20professional%20legal%20documentation%20setup%2C%20clean%20office%20environment&width=400&height=300&seq=process4&orientation=landscape'
    }
  ];

  return (
    <section id="flow" className="py-20 bg-gradient-to-b from-white to-beige-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="font-en text-navy-600 text-sm tracking-widest mb-4 uppercase">Flow</p>
          <h2 className="font-noto text-3xl md:text-4xl font-bold text-navy-900 mb-6">
            解決の流れ
          </h2>
          <p className="font-noto text-lg text-navy-700">
            弁護士による負動産処分の4つのステップ
          </p>
        </div>

        <div className="space-y-4">
          {steps.map((step) => (
            <div key={step.id} className={`rounded-lg border-2 ${step.color} ${step.bgColor} overflow-hidden`}>
              {/* アコーディオンヘッダー */}
              <button
                onClick={() => toggleStep(step.id)}
                className="w-full p-6 text-left hover:bg-white/50 transition-colors duration-200 cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className={`w-16 h-16 ${step.iconBg} rounded-full flex items-center justify-center mr-6`}>
                      <i className={`${step.icon} ${step.iconColor} text-2xl`}></i>
                    </div>
                    <div>
                      <div className="flex items-center mb-2">
                        <span className="font-en text-navy-700 font-bold text-sm mr-3">
                          STEP {step.id}
                        </span>
                        <h3 className="font-noto text-xl md:text-2xl font-bold text-navy-900">
                          {step.title}
                        </h3>
                      </div>
                      <p className="font-noto text-navy-600 text-sm">
                        {step.subtitle}
                      </p>
                    </div>
                  </div>
                  <div className="flex-shrink-0 ml-4">
                    <i className={`ri-arrow-${openStep === step.id ? 'up' : 'down'}-s-line text-2xl text-navy-500 transition-transform duration-200`}></i>
                  </div>
                </div>
              </button>

              {/* アコーディオンコンテンツ */}
              <div className={`transition-all duration-500 ease-in-out ${
                openStep === step.id 
                  ? 'max-h-[2000px] opacity-100' 
                  : 'max-h-0 opacity-0'
              } overflow-hidden`}>
                <div className="px-6 pb-6">
                  {step.id === 1 && (
                    <div className="grid md:grid-cols-2 gap-8">
                      <div>
                        <img 
                          src={step.image}
                          alt="法律相談"
                          className="w-full h-64 object-cover rounded-lg mb-6"
                        />
                        <div className="bg-navy-50 p-4 rounded-lg border border-navy-200">
                          <h4 className="font-noto font-bold text-navy-800 mb-2 flex items-center">
                            <i className="ri-gift-line mr-2"></i>
                            初回相談無料
                          </h4>
                          <p className="font-noto text-navy-700 text-sm mb-3">
                            初回の法律相談は無料で承っております。お気軽にご相談ください。
                          </p>
                          <h4 className="font-noto font-bold text-navy-800 mb-2 flex items-center">
                            <i className="ri-video-line mr-2"></i>
                            対面・ウェブ会議のみ対応
                          </h4>
                          <p className="font-noto text-navy-700 text-sm mb-3">
                            対面またはウェブ会議による法律相談のみ承っております。事前予約制となります。
                          </p>
                          <div className="bg-navy-100 p-3 rounded border border-navy-300">
                            <h5 className="font-noto font-bold text-navy-900 mb-1 flex items-center text-sm">
                              <i className="ri-close-circle-line mr-1"></i>
                              対応不可
                            </h5>
                            <p className="font-noto text-navy-800 text-xs">
                              電話会議・LINE・メールによる法律相談は受け付けておりません。
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <div className="bg-white p-6 rounded-lg border border-beige-200">
                          <h4 className="font-noto font-bold text-navy-800 mb-3">📋 ヒアリング内容</h4>
                          <ul className="space-y-2 font-noto text-navy-700 text-sm">
                            <li>• 物件の所在地・種類・現況</li>
                            <li>• 相続の経緯・共有者の有無</li>
                            <li>• 過去の処分試行の有無</li>
                            <li>• 希望する処分時期・条件</li>
                          </ul>
                        </div>
                        <div className="bg-white p-6 rounded-lg border border-beige-200">
                          <h4 className="font-noto font-bold text-navy-800 mb-3">💡 この段階で決まること</h4>
                          <ul className="space-y-2 font-noto text-navy-700 text-sm">
                            <li>• 処分の実現可能性</li>
                            <li>• 最適な処分方法の選択</li>
                            <li>• 概算費用と期間の見積もり</li>
                            <li>• 今後の進め方</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {step.id === 2 && (
                    <div className="grid md:grid-cols-2 gap-8">
                      <div>
                        <img 
                          src={step.image}
                          alt="物件調査"
                          className="w-full h-64 object-cover rounded-lg mb-6"
                        />
                      </div>
                      <div className="space-y-4">
                        <div className="bg-white p-6 rounded-lg border border-beige-200">
                          <h4 className="font-noto font-bold text-navy-800 mb-3">🔍 調査項目</h4>
                          <ul className="space-y-2 font-noto text-navy-700 text-sm">
                            <li>• 登記簿謄本・公図の確認</li>
                            <li>• 都市計画・農地法等の法的制約</li>
                            <li>• 境界・越境の有無</li>
                            <li>• 建物の状況・解体の要否</li>
                          </ul>
                        </div>
                        <div className="bg-white p-6 rounded-lg border border-beige-200">
                          <h4 className="font-noto font-bold text-navy-800 mb-3">📊 検討結果</h4>
                          <ul className="space-y-2 font-noto text-navy-700 text-sm">
                            <li>• 処分に必要な手続きの特定</li>
                            <li>• 法的リスクの洗い出し</li>
                            <li>• 最適な譲渡方法の決定</li>
                            <li>• 処分戦略の策定</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {step.id === 3 && (
                    <div className="grid md:grid-cols-2 gap-8">
                      <div>
                        <img 
                          src={step.image}
                          alt="交渉・調整"
                          className="w-full h-64 object-cover rounded-lg mb-6"
                        />
                      </div>
                      <div className="space-y-4">
                        <div className="bg-white p-6 rounded-lg border border-beige-200">
                          <h4 className="font-noto font-bold text-navy-800 mb-3">🤝 交渉先</h4>
                          <ul className="space-y-2 font-noto text-navy-700 text-sm">
                            <li>• 隣接地所有者への譲渡提案</li>
                            <li>• 農業委員会・行政機関との協議</li>
                            <li>• 事業者・個人への処分提案</li>
                            <li>• 自治体への寄付交渉</li>
                          </ul>
                        </div>
                        <div className="bg-white p-6 rounded-lg border border-beige-200">
                          <h4 className="font-noto font-bold text-navy-800 mb-3">⚖️ 弁護士の強み</h4>
                          <ul className="space-y-2 font-noto text-navy-700 text-sm">
                            <li>• 法的根拠に基づく説得力</li>
                            <li>• 相手方の信頼獲得</li>
                            <li>• 条件交渉の専門性</li>
                            <li>• トラブル予防の視点</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {step.id === 4 && (
                    <div className="grid md:grid-cols-2 gap-8">
                      <div>
                        <img 
                          src={step.image}
                          alt="契約・完了"
                          className="w-full h-64 object-cover rounded-lg mb-6"
                        />
                      </div>
                      <div className="space-y-4">
                        <div className="bg-white p-6 rounded-lg border border-beige-200">
                          <h4 className="font-noto font-bold text-navy-800 mb-3">📝 契約書作成</h4>
                          <ul className="space-y-2 font-noto text-navy-700 text-sm">
                            <li>• 瑕疵担保責任の明確化</li>
                            <li>• 費用負担の取り決め</li>
                            <li>• 停止条件の設定</li>
                            <li>• 紛争予防条項の挿入</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;